module.exports = __webpack_public_path__ + "south-sudan.svg?e6d5e8f763361fd1adc2b46a39987d97";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/south-sudan.svg
// module id = 301
// module chunks = 10